
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseConfig } from './../../../../shared/service/base-config.service';
import { GenericHttpService } from './../../../../shared/service/generic-http.service';
import { DadosOnInitModelView } from './../model/regularizacaoDespesaOrcamento.model';

@Injectable()
export class RegularizacaoDespesaOrcamentoService {
  private readonly urlBase: string;

  constructor(
    private baseConfig: BaseConfig,
    private readonly http: GenericHttpService<any>) {
  }

  public dadosOnInitFormulario(): Observable<DadosOnInitModelView> {

    let retorno: Observable<DadosOnInitModelView> = null;

    retorno = this.http.getAny(this.baseConfig.getBaseUrlApi().concat('/consulta/IndiceParticipacaoMunicipios/DadosOnInitFormulario'), null);

    return retorno;
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/regularizacao-despesa-orcamentaria/shared/service/regularizacaoDespesaOrcamento.service.ts